var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal8List({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-External_4_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External_4_List",
    "data-name": "External 4_List",
    clipPath: "url(#clip-External_4_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_668",
    "data-name": "Ellipse 668",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#f36d54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20393",
    "data-name": "Group 20393",
    transform: "translate(5 4.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32845",
    "data-name": "Path 32845",
    d: "M2.027,0a2.217,2.217,0,0,1,.557.162A1.927,1.927,0,0,1,3.13.55Q4.323,1.742,5.516,2.934c.053.053.058.084,0,.139q-.264.254-.519.519c-.053.055-.083.055-.138,0Q3.675,2.4,2.483,1.21A.933.933,0,0,0,1.877.921a.9.9,0,0,0-.687,1.54q.195.2.4.4c.044.042.041.068,0,.109-.184.18-.365.363-.546.545-.028.028-.052.057-.093.015a7.238,7.238,0,0,1-.6-.631,1.781,1.781,0,0,1-.337-.824A.451.451,0,0,0,0,2.027V1.6c0-.017.009-.034.012-.051A1.81,1.81,0,0,1,1.027.172,2.035,2.035,0,0,1,1.6,0Z",
    transform: "translate(0.592 1.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32846",
    "data-name": "Path 32846",
    d: "M281.094,2.027a2.2,2.2,0,0,1-.165.563,1.908,1.908,0,0,1-.379.533q-1.148,1.151-2.3,2.3c-.051.052-.081.053-.132,0q-.257-.267-.524-.524c-.052-.05-.053-.079,0-.131q1.147-1.142,2.29-2.287a.933.933,0,0,0,.288-.607.9.9,0,0,0-1.535-.691c-.134.129-.266.262-.4.4-.042.043-.069.051-.115,0-.179-.184-.363-.365-.545-.546-.028-.028-.056-.052-.014-.093a7.218,7.218,0,0,1,.631-.6A1.774,1.774,0,0,1,279.03.01a.271.271,0,0,0,.036-.01h.424a.316.316,0,0,0,.036.01,1.806,1.806,0,0,1,1.4,1.024,2.026,2.026,0,0,1,.169.57Z",
    transform: "translate(-272.755 1.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32847",
    "data-name": "Path 32847",
    d: "M154.263,281.089a2.2,2.2,0,0,1-.563-.165,1.907,1.907,0,0,1-.533-.379q-1.151-1.149-2.3-2.3c-.051-.051-.054-.081,0-.132q.267-.257.524-.524c.05-.052.079-.053.131,0q1.142,1.147,2.287,2.29a.933.933,0,0,0,.607.288.9.9,0,0,0,.691-1.535c-.129-.135-.262-.266-.4-.4-.043-.041-.051-.068,0-.115.184-.179.365-.363.546-.544.028-.028.052-.057.093-.014a7.24,7.24,0,0,1,.6.631,1.781,1.781,0,0,1,.337.824.45.45,0,0,0,.011.044v.424c0,.017-.009.034-.012.051a1.81,1.81,0,0,1-1.016,1.38,2.035,2.035,0,0,1-.576.172Z",
    transform: "translate(-147.952 -272.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32848",
    "data-name": "Path 32848",
    d: "M0,153.814a2.2,2.2,0,0,1,.165-.563,1.948,1.948,0,0,1,.39-.544l2.283-2.284c.07-.07.07-.07.14,0,.173.173.344.348.52.518.052.05.052.08,0,.131q-1.147,1.142-2.29,2.287a.933.933,0,0,0-.288.607.9.9,0,0,0,1.535.691c.134-.129.266-.262.4-.4.042-.043.069-.051.115,0,.179.184.363.365.545.546.028.028.056.052.014.093a7.209,7.209,0,0,1-.631.6,1.774,1.774,0,0,1-.831.338.276.276,0,0,0-.036.01H1.6a.324.324,0,0,0-.036-.01,1.806,1.806,0,0,1-1.4-1.024,2.025,2.025,0,0,1-.169-.57Z",
    transform: "translate(0.592 -146.878)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal8List);
export default __webpack_public_path__ + "static/media/External 8_List.8006b418ea79cab73a58d525ca241648.svg";
export { ForwardRef as ReactComponent };